"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _core = require("@emotion/core");

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var Linkedin = function Linkedin(props) {
  return (0, _core.jsx)("svg", (0, _extends2.default)({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25"
  }, props), (0, _core.jsx)("path", {
    d: "M5.813 2.833c0 1.564-1.302 2.833-2.907 2.833S0 4.397 0 2.833C0 1.268 1.301 0 2.906 0c1.605 0 2.907 1.268 2.907 2.833zM0 25h5.644V8.449H0V25zm26-9.492V25h-5.646v-8.855c0-2.224-.815-3.743-2.859-3.743-1.56 0-2.487 1.023-2.896 2.013-.148.354-.187.845-.187 1.341V25H8.766s.076-14.998 0-16.551h5.646v2.345c-.011.019-.027.037-.037.054h.037v-.054c.75-1.125 2.089-2.734 5.088-2.734 3.715 0 6.5 2.366 6.5 7.448z",
    fill: "currentColor"
  }));
};

var _default = Linkedin;
var _default2 = _default;
exports.default = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(Linkedin, "Linkedin", "/builds/bA1zbJom/0/gojob/ui-bits/src/Footer/assets/Linkedin.tsx");
  reactHotLoader.register(_default, "default", "/builds/bA1zbJom/0/gojob/ui-bits/src/Footer/assets/Linkedin.tsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9Gb290ZXIvYXNzZXRzL0xpbmtlZGluLnRzeCJdLCJuYW1lcyI6WyJMaW5rZWRpbiIsInByb3BzIl0sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7OztBQUFBOzs7Ozs7Ozs7Ozs7O0FBRUEsSUFBTUEsUUFBMEQsR0FBRyxTQUE3REEsUUFBNkQsQ0FBQ0MsS0FBRCxFQUFXO0FBQzVFLFNBQ0U7QUFBSyxJQUFBLEtBQUssRUFBRSxFQUFaO0FBQWdCLElBQUEsTUFBTSxFQUFFLEVBQXhCO0FBQTRCLElBQUEsT0FBTyxFQUFDO0FBQXBDLEtBQW9EQSxLQUFwRCxHQUNFO0FBQ0UsSUFBQSxDQUFDLEVBQUMsbVpBREo7QUFFRSxJQUFBLElBQUksRUFBQztBQUZQLElBREYsQ0FERjtBQVFELENBVEQ7O2VBV2VELFE7Ozs7Ozs7Ozs7OzswQkFYVEEsUSIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCwgeyBGdW5jdGlvbkNvbXBvbmVudCB9IGZyb20gJ3JlYWN0JztcblxuY29uc3QgTGlua2VkaW46IEZ1bmN0aW9uQ29tcG9uZW50PFJlYWN0LlNWR1Byb3BzPFNWR1NWR0VsZW1lbnQ+PiA9IChwcm9wcykgPT4ge1xuICByZXR1cm4gKFxuICAgIDxzdmcgd2lkdGg9ezI2fSBoZWlnaHQ9ezI1fSB2aWV3Qm94PVwiMCAwIDI2IDI1XCIgey4uLnByb3BzfT5cbiAgICAgIDxwYXRoXG4gICAgICAgIGQ9XCJNNS44MTMgMi44MzNjMCAxLjU2NC0xLjMwMiAyLjgzMy0yLjkwNyAyLjgzM1MwIDQuMzk3IDAgMi44MzNDMCAxLjI2OCAxLjMwMSAwIDIuOTA2IDBjMS42MDUgMCAyLjkwNyAxLjI2OCAyLjkwNyAyLjgzM3pNMCAyNWg1LjY0NFY4LjQ0OUgwVjI1em0yNi05LjQ5MlYyNWgtNS42NDZ2LTguODU1YzAtMi4yMjQtLjgxNS0zLjc0My0yLjg1OS0zLjc0My0xLjU2IDAtMi40ODcgMS4wMjMtMi44OTYgMi4wMTMtLjE0OC4zNTQtLjE4Ny44NDUtLjE4NyAxLjM0MVYyNUg4Ljc2NnMuMDc2LTE0Ljk5OCAwLTE2LjU1MWg1LjY0NnYyLjM0NWMtLjAxMS4wMTktLjAyNy4wMzctLjAzNy4wNTRoLjAzN3YtLjA1NGMuNzUtMS4xMjUgMi4wODktMi43MzQgNS4wODgtMi43MzQgMy43MTUgMCA2LjUgMi4zNjYgNi41IDcuNDQ4elwiXG4gICAgICAgIGZpbGw9XCJjdXJyZW50Q29sb3JcIlxuICAgICAgLz5cbiAgICA8L3N2Zz5cbiAgKTtcbn07XG5cbmV4cG9ydCBkZWZhdWx0IExpbmtlZGluO1xuIl19